import { defineComponent as f, computed as o } from "vue";
import { MsInformationCircle as e, MsError as c } from "@sunrise/icons";
import { Components as t } from "@sunrise/types";
const p = f({
  name: "CsNotification",
  components: {
    MsError: c,
    MsInformationCircle: e
  },
  props: {
    notificationState: {
      default: t.CsNotification.NotificationState.ERROR,
      type: String
    }
  },
  setup(i) {
    const n = o(
      () => i.notificationState === t.CsNotification.NotificationState.INFO
    ), a = o(
      () => i.notificationState === t.CsNotification.NotificationState.ERROR
    );
    return { isInfoNotification: n, isErrorNotification: a };
  }
});
export {
  p as default
};
